import { Component, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { tap } from 'rxjs';
import { PreferencesService } from '../services/preferences.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-terms-acceptor',
  templateUrl: './terms-acceptor.component.html'
})
export class TermsAcceptorComponent implements OnInit {
  hasAcceptedTerms: boolean;
  languageCode: string = 'en';
  termsForm: UntypedFormGroup;
  constructor(private prefService: PreferencesService,
    private fb: UntypedFormBuilder,private preferenceService: PreferencesService, 
    private router:Router) {



    this.prefService.termsAndConditions$.subscribe(hasAcceptedTerms => this.hasAcceptedTerms = hasAcceptedTerms);
    this.prefService.languageCode$.pipe(tap(languageCode => {
      this.languageCode = languageCode || 'en';
    })).subscribe();

    this.termsForm = this.fb.group({
      acceptTerms: [false],
      countryCode: [null],
    });
    this.termsForm.valueChanges.subscribe(
      values => {
        if (values.acceptTerms) {
          this.prefService.termsAndConditions = true;
        }
      }
    );


  }

  ngOnInit(): void {
  }

  changeLanguage(code: string) {
    this.preferenceService.languageCode = code;
    this.preferenceService.needsReload=true;
  
  
    this.router.navigateByUrl('');
  }


  get pathToTerms(): string {
    switch (this.languageCode) {
     
      default:
        return `assets/terms/terms-${this.languageCode}.md`;
    }
  }
}
